export function LogoMark({ size = 22, stroke = "#F3F3F0" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <path d="M14 18 L32 50 L50 18" stroke={stroke} strokeWidth="5" />
      <path d="M24 18 L32 33 L40 18" stroke="#D1C7BD" strokeWidth="2.5" />
    </svg>
  );
}

export default function Logo({ size = 22 }) {
  return (
    <span className="inline-flex items-center gap-3 select-none">
      <LogoMark size={size} />
      <span className="wordmark text-[15px] leading-none text-[#F3F3F0]" style={{ marginRight: "-0.34em" }}>
        VEYRONE
      </span>
    </span>
  );
}
